import * as React from 'react';

export class Paypal extends React.Component {
    
    
    render(){

        let tipo = '_xclick'; // standard da fare utilizzare i clienti
        
        let email = this.props.email;
        let numfattura = this.props.numfattura;
        let amount = this.props.amount;
        let cliente = this.props.cliente;
        let metodipagamento = this.props.metodipagamento;
        let pagamento = this.props.pagamento;
        
        let visualizza = false;
        
        if(amount === null) amount = 0;
        amount = amount.replace(',' , '.');

        let descrizione = 'Fatt. N. '+numfattura;
        if(cliente !== null && cliente!==''){
            descrizione = descrizione+' - Cod. Cliente '+cliente;
        }
        
        let itemnumber = numfattura;
        if(cliente !== null && cliente!==''){
            itemnumber = itemnumber+'-'+cliente;
        }
        
        if( email === '' || email  === null ){ amount = 0; }
        
        
        if( metodipagamento === '' || metodipagamento === null){ visualizza = true;}
        else{
            let elencopagamenti = metodipagamento.split('|');
            
            for (let i = 0 ; i<elencopagamenti.length ; i++ ){
                if(elencopagamenti[i] === pagamento){ visualizza = true; }
            }
        }

       
        if( true === visualizza && tipo === '_xclick'){
            return ( 
                <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank">
                    <input type="hidden" name="cmd" value="_xclick" />
                    <input type="hidden" name="business" value={email} />
                    <input type="hidden" name="item_name" value={descrizione} />
                    <input type="hidden" name="item_number" value={itemnumber} />
                    <input type="hidden" name="amount" value={amount} />
                    <input type="hidden" name="Ic" value="IT" />
                    <input type="hidden" name="currency_code" value="EUR" />
                    <input type="image" src="https://www.paypal.com/it_IT/i/btn/x-click-but01.gif" name="submit" alt="PayPal, il modo sicuro di pagare e farsi pagare online!" />
                    <img alt="" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
                </form>
            );
        }
        
        
        if( false === visualizza ){ return '';}

    }
}

export default Paypal;


// WEBPACK FOOTER //
// ./src/AcComponents/Paypal.js